import React from "react";
import { CheckIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { volumes } from "../../data/content";
export function Volumes() {
  return <section className="w-full bg-white px-4 py-16 sm:py-20" aria-label="What's inside" data-id="element-315" data-mp="2x104aphl813t">
      <div className="mx-auto max-w-5xl" data-id="element-316" data-mp="2szoo1aklss8a">
        <SectionHeading title={<>What's inside the <em className="text-gold" data-id="element-318" data-mp="2t2157lijeyka">Blepharoplasty Decision Lab™</em>?</>} subtitle="6 premium volumes, each focused on one part of your case-review practice." data-id="element-317" data-mp="2syn1a8u86haq" />

        <div className="grid gap-5 md:grid-cols-2" data-id="element-319" data-mp="2j8k55zrt4n86">
          {volumes.map(v => <article key={v.number} className="flex flex-col overflow-hidden rounded-2xl bg-cream ring-1 ring-navy/10" data-id="element-320" data-mp="2ebbltvuxad5c">
              <div className="flex items-center gap-4 bg-navy px-5 py-4" data-id="element-321" data-mp="299meoratmjmj">
                <span className="font-serif text-4xl font-bold text-gold-light" data-id="element-322" data-mp="259kl75f8owic">{v.number}</span>
                <div data-id="element-323" data-mp="20bj2wmpn117x">
                  <p className="text-xs font-bold uppercase tracking-wider text-white/60" data-id="element-324" data-mp="20d3uq4kki623">Volume {v.number}</p>
                  <h3 className="font-serif text-xl font-bold leading-tight text-white" data-id="element-325" data-mp="333t8zy0fk5fo">{v.title}</h3>
                </div>
              </div>
              <div className="flex flex-1 flex-col p-5" data-id="element-326" data-mp="2u5zcon2o1bsi">
                <p className="text-base leading-relaxed text-ink/85" data-id="element-327" data-mp="2y6j7vl3oi5c0">{v.intro}</p>
                <ul className="mt-4 space-y-2" data-id="element-328" data-mp="2y4gm5d9k6yd3">
                  {v.items.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] text-ink" data-id="element-329" data-mp="3lwx5rs8y2yei">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-330" data-mp="3qufdjfb877kx" />
                      {item}
                    </li>)}
                </ul>
                {v.outro && <p className="mt-auto pt-4 text-[15px] font-semibold italic text-navy" data-id="element-331" data-mp="3hwd7glcmxoqs">{v.outro}</p>}
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}